var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wizard',{staticClass:"wizard",attrs:{"icon":"mdi-timer-sand"}},[_c('div',{staticClass:"text-h5"},[_vm._v(" Loading "),_c('v-progress-linear',{staticClass:"mt-1",attrs:{"indeterminate":"","color":"primary","height":"2"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }